import { useState } from 'react';
import Footer from '../../components/footer/Footer';
import Menu from '../../components/menu/menu';
import Modal from '../../elements/Modal/modal';
import classes from './solutions.module.scss';
import Appointment from '../../components/appointment/appointment';
import { FaCheck, FaCheckCircle, FaClipboardCheck, FaMagic, FaMicroscope, FaTooth } from 'react-icons/fa';
import { RiBox3Fill } from "react-icons/ri";


export default function Solutions() {

    const [isModalOpen, setModalOpen] = useState(false);

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    return (
        <div className={classes.module}>
            <div className={classes.header}>
                <Menu />
            </div>
            <div className={classes.content}>
                <div className={classes.transforming}>
                    <img src="/images/solutions-banner.png" alt="Transforming Dentistry with AI Precision" />
                    <div className={classes.desc}>
                        <span className={classes.title}>Transforming <br /> Dentistry with AI <br /> Precision</span>
                        <span className={classes.text}>Experience the future of dental care with our AI-powered platform that revolutionizes smile design, diagnosis, and treatment planning.</span>
                        <div className={classes.buttons}>
                            <button className={classes.primary} onClick={() => window.open('https://panel.tx-genius.com/', '_blank')}>Get Started</button>
                            <button className={classes.outline} onClick={handleOpenModal}>Book a Demo</button>
                        </div>
                    </div>
                </div>

                <div className={classes.aiPowered}>
                    <img src="/images/before-after.png" alt="AI-Powered Smile Design" />
                    <div className={classes.desc}>
                        <span className={classes.title}><FaMagic /> AI-Powered Smile Design</span>
                        <span className={classes.text}>Traditional smile design takes days or weeks and often excludes patient input. At Tx-Genius, we put patients at the center with our patented AI-powered process—the only one in the world that designs smiles based on age, gender, and ethnicity.</span>
                        <div className={classes.tips}>
                            <span><FaCheck /> Instant personalized smile generation</span>
                            <span><FaCheck /> Real-time patient feedback</span>
                            <span><FaCheck /> Extensive tooth shape library</span>
                        </div>
                    </div>
                </div>

                <div className={classes.cadDesign}>
                    <div className={classes.desc}>
                        <span className={classes.title}><RiBox3Fill /> 3D CAD Design</span>
                        <span className={classes.text}>From Smile Design to Smile Reality, our patented algorithm streamlines the process, making treatment faster, more predictable, and patient-centered.</span>
                        <div className={classes.tips}>
                            <div>
                                <h4>Cosmetic Dentistry</h4>
                                <span>Try-in 3D-printed veneers during the same visit</span>
                            </div>
                            <div>
                                <h4>Implant Dentistry</h4>
                                <span>Deliver permanent zirconia implant bridges within 48-72 hours</span>
                            </div>
                        </div>
                    </div>
                    <img src="/images/ai-driven-diagnosis.png" alt="3D CAD Design"/>
                </div>

                <div className={classes.aiPowered}>
                    <img src="/images/3D-2D.png" alt=" AI-Driven Diagnosis" />
                    <div className={classes.desc}>
                        <span className={classes.title}><FaMicroscope /> AI-Driven Diagnosis</span>
                        <span className={classes.text}>Our AI-driven platform ensures a thorough diagnosis using our patented process, which analyzes the patient's age, gender, and ethnicity.</span>
                        <div className={classes.tips}>
                            <span><FaCheck /> Comprehensive facial analysis</span>
                            <span><FaCheck /> Critical diagnosis detection</span>
                            <span><FaCheck /> Predictable treatment outcomes</span>
                        </div>
                    </div>
                </div>

                <div className={classes.approval}>
                    <div className={classes.desc}>
                        <span className={classes.title}><FaClipboardCheck />Patient Approval Workflow</span>
                        <span className={classes.text}>Take control of the process by involving the patient at every step and securing their e-signature approval through our platform.</span>
                        <div className={classes.tips}>
                            <span><FaCheckCircle /> Initial consultation</span>
                            <span><FaCheckCircle /> 3D-printed mock-up try-in</span>
                            <span><FaCheckCircle /> AI provisional veneers</span>
                            <span><FaCheckCircle /> Pre-permanent delivery</span>
                        </div>
                    </div>
                    <img src="/images/cadDesign.png" alt="Patient Approval Workflow" />
                </div>

                <div className={classes.aiPowered}>
                    <img src="/images/alignment-2.png" alt="3D Bridge Design & Implant Planning" width={624} height={624} />
                    <div className={classes.desc}>
                        <span className={classes.title}><FaTooth /> 3D Bridge Design & Implant Planning</span>
                        <span className={classes.text}>Deliver permanent restorations within 48-72 hours of surgery and ensure precision at every step.</span>
                        <div className={classes.tips}>
                            <span><FaCheck /> Optimal bone reduction planning</span>
                            <span><FaCheck /> Precise implant positioning</span>
                            <span><FaCheck /> Evidence-based abutment calculation</span>
                            <span><FaCheck /> Optimized prosthesis design</span>
                            <button onClick={handleOpenModal}>Schedule Demo</button>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

            <Modal isOpen={isModalOpen} onClose={handleCloseModal} background='var(--blue-50)'>
                <Appointment />
            </Modal>
        </div>
    )
}
